import { render, staticRenderFns } from "./DashboardPanelKey.vue?vue&type=template&id=9cdedf80&"
import script from "./DashboardPanelKey.vue?vue&type=script&lang=js&"
export * from "./DashboardPanelKey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9cdedf80')) {
      api.createRecord('9cdedf80', component.options)
    } else {
      api.reload('9cdedf80', component.options)
    }
    module.hot.accept("./DashboardPanelKey.vue?vue&type=template&id=9cdedf80&", function () {
      api.rerender('9cdedf80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/inputs/DashboardPanelKey.vue"
export default component.exports